var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineaCurva(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1304.25 176.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pantalla_de_servicios",
    "data-name": "Pantalla de servicios"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Marco"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m259.65,176.75c-54.03,0-103.8-6.56-150.9-19.81-33.44-9.41-68-22.89-108.75-42.44l6.6-13.76c39.93,19.16,73.7,32.34,106.28,41.51,62.03,17.45,128.98,22.95,204.68,16.82,61.23-4.96,128.64-17.77,206.08-39.17,42.08-11.63,84.6-24.88,125.72-37.69,90.99-28.36,185.09-57.68,281.16-71.59,126.03-18.25,254.11-9.89,373.74,1.87l-1.49,15.18c-200.81-19.73-296.53-12.6-370.06-1.95-94.88,13.74-188.38,42.88-278.81,71.05-41.24,12.85-83.88,26.14-126.19,37.83-78.37,21.66-146.71,34.63-208.91,39.67-20.29,1.64-39.99,2.47-59.14,2.47Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineaCurva);
export default __webpack_public_path__ + "static/media/Linea-Curva.ec1d39573227a1d13163e4adfdac6721.svg";
export { ForwardRef as ReactComponent };